module.exports = __webpack_public_path__ + "static/media/shaws-dept-store.aacff83b.png";